import { EventEmitter, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppUser } from './app.user';
import { IServiceResponse } from '../../_helpers/helperInterfaces';
import { AlertMessage } from '../../_helpers/helperClasses';


 

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  authKey: string = "currentAppUser";
  clientId: string = "MOF_ANGULAR_7";
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8;'
    })
  };
  private currentAppUserSubject: BehaviorSubject<AppUser>;
  public currentAppUser: Observable<AppUser>;
  public alertMessages: BehaviorSubject<AlertMessage[]>;

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: any) {
    this.currentAppUserSubject = new BehaviorSubject<AppUser>(JSON.parse(localStorage.getItem('currentAppUser')));
    this.currentAppUser = this.currentAppUserSubject.asObservable();
    this.alertMessages = new BehaviorSubject<AlertMessage[]>([]);
  }

  public get currentAppUserValue(): AppUser {
    return this.currentAppUserSubject.value;
  }

  login(AppUsername: string, password: string): Observable<boolean> {

    var data = {
      username: AppUsername,
      password: password,
      client_id: this.clientId,
      // required when signing up with username/password
      grant_type: "password",
      // space-separated list of scopes for which the token is  issued
      scope: "offline_access profile email"
    };
    return this.getAuthFromServer(data);
  }


  login2(AppUsername: string, password: string): Observable<boolean> {

    var data = {
      username: AppUsername,
      password: password,
      client_id: this.clientId,
      // required when signing up with username/password
      grant_type: "password2",
      // space-separated list of scopes for which the token is  issued
      scope: "offline_access profile email"
    };
    return this.getAuthFromServer(data);
  }


  // try to refresh token
  refreshToken() : Observable<boolean>{
    var data = {
      client_id: this.clientId,
      // required when signing up with username/password
      grant_type: "refresh_token",
      refresh_token: this.getAuth()!.refresh_token,
      // space-separated list of scopes for which the token is issued
      scope: "offline_access profile email"
    };
    return this.getAuthFromServer(data);
  }


  // retrieve the access & refresh tokens from the server
  getAuthFromServer(data: any): Observable<boolean> {
    return this.http.post<IServiceResponse<AppUser>>('api/token/auth', JSON.stringify(data), this.httpOptions)
      .pipe(map(AppUser => {
        // login successful if there's a jwt token in the response
        if (AppUser && AppUser.results && AppUser.results.token) {

          this.setAuth(AppUser.results);


          this.alertMessages.next([]);

          return true;
        }

        this.alertMessages.next(AppUser.alerts);
        // failed login
        return Observable.throw('Unauthorized');
      }), catchError(err => {
        return new Observable<any>(err);
      }));
  }

  logout(): boolean {
    // remove AppUser from local storage to log AppUser out
    this.setAuth(null);
    return true;
  }


  // Persist auth into localStorage or removes it if a NULL argument is given
  setAuth(auth: AppUser | null): boolean {
    if (isPlatformBrowser(this.platformId)) {
      if (auth) {

        // store AppUser details and jwt token in local storage to keep AppUser logged in between page refreshes
        localStorage.setItem(this.authKey, JSON.stringify(auth));
        this.currentAppUserSubject.next(auth);
      }
      else {
        localStorage.removeItem(this.authKey);
        this.currentAppUserSubject.next(null);
      }
    }
    return true;
  }

  // Retrieves the auth JSON object (or NULL if none)
  getAuth(): AppUser | null {
    if (isPlatformBrowser(this.platformId)) {
      var i = localStorage.getItem(this.authKey);
      if (i) {
        return JSON.parse(i);
      }
    }
    return null;
  }

  // Returns TRUE if the user is logged in, FALSE otherwise.
  isLoggedIn(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(this.authKey) != null;
    }
    return false;
  }

  isundergoingmaintenance(): Observable<boolean> {

    return this.http.post<IServiceResponse<boolean>>('api/token/isundergoingmaintenance', JSON.stringify({}), this.httpOptions)
      .pipe(map(ismaintaining => {
         
        if (ismaintaining) {

         

          return true;
        }

       
        // failed login
        return false;
      }), catchError(err => {
        return new Observable<any>(err);
      }));

  }

  //Send Password Reset Email
  getPasswordReset(data: any): Observable<IServiceResponse<any>>{
      return this.http.post<IServiceResponse<any>>('api/token/bidders_passwordReset', JSON.stringify({ email: data }), this.httpOptions);

  }

  changePassword(rkey: any, newPwd: string): Observable<IServiceResponse<any>> {
    return this.http.post<IServiceResponse<any>>('api/token/bidders_passwordChange', JSON.stringify({ rkey: rkey, newPwd: newPwd }), this.httpOptions);


  }


  changePasswordValidLink(rkeyValid: any): Observable<IServiceResponse<any>> {
    return this.http.post<IServiceResponse<any>>('api/token/bidders_passwordChangeValidLink', JSON.stringify({ rkeyValid: rkeyValid }), this.httpOptions);


  }


  submissionEmail(data: any): Observable<IServiceResponse<any>> {
    return this.http.post<IServiceResponse<any>>('api/token/bidders_submissionEmail', JSON.stringify({ email: data }), this.httpOptions);

  }







}
